"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var useEffect = typeof window === 'undefined' ? _react.default.useEffect : _react.default.useLayoutEffect;
var _default = exports.default = useEffect;